import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserBehaviourRoutingModule } from './user-behaviour-routing.module';
import { UserBehaviourComponent } from './user-behaviour.component';
import { SessionGraphComponent } from './graphs/line/session-graph.component';
import { LogMoreInfoDialogComponent } from './dailogs/log-more-info-dialog.component';
import { TimeSinceLoginPipe } from './filter/time-since-login.pipe';
import { SessionBarComponent } from './graphs/bar/session-bar.component';
import { ActiveUsersDonutChartComponent } from './graphs/donut/active-users-donut-chart.component';
import { UserLogTableComponent } from './log-table/user-log.component';
import { SessionSummaryComponent } from './summary/session-summary.component';
import { SessionDataService } from './service/session-data.service';
import { MaterialModule } from 'src/app/shared/material.module';
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { FormsModule } from '@angular/forms';
import { PageDetailsDialogComponent } from './dailogs/page-details/page-details-dialog.component';
import { PageActivityTableComponent } from './page-activity-table/page-activity-table.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { SiteDetailsDialogComponent } from './dailogs/site-details-dialog/site-details-dialog.component';
import { AddEditUserDialogComponent } from './dailogs/add-edit-user-dialog/add-edit-user-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { RestrictUserDialogComponent } from './dailogs/restrict-user-dialog/restrict-user-dialog.component';
import { HealthCheckComponent } from './health/health-check.component';
import { CameraViewComponent } from './cam-view/camera-view-component';
import { VideoProgressComponent } from './buffering/video-progress.component';
import { VideoComponent } from './buffering/video.component';
import { EventNewTimelineComponent } from './event-timeline/event-timeline.component';
import { CameraMappingComponent } from './camera-mapping/camera-mapping.component';
import { AgGridModule } from 'ag-grid-angular';
import { PageSummaryComponent } from './page-summary/page-summary.component';
import { NewTipsComponent } from './new-tips/new-tips.component';
import { NewTipsDialogComponent } from './new-tips-dialog/new-tips-dialog.component';
import { ChangePasswordDialogComponent } from './dailogs/change-password-dialog/change-password-dialog.component';
import { PreferencesDialogComponent } from './dailogs/preferences-dialog/preferences-dialog.component';
import { AssignedUsersDialogComponent } from './dailogs/assigned-users-dialog/assigned-users-dialog.component';
import { SiteSummaryDetailsDialogComponent } from './dailogs/site-summary-details-dialog/site-summary-details-dialog.component';
import { DateFormatPipe } from 'src/app/date-format.pipe';
import { DashboardComponent } from './user-management/dashboard/dashboard.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmationDailogsComponent } from './dailogs/confirmation-dailogs/confirmation-dailogs.component';
import { ArchiveDashboardComponent, QueueDetailsModalComponent, CameraIdsDialogComponent, ConfirmationDialogComponent, PerformanceDetailsDialogComponent } from './archive-dashboard/archive-dashboard.component';
import { ArchiveDashboardService } from './archive-dashboard/archive-dashboard.service';
import { PerformanceMonitoringService } from 'src/app/services/performance-monitoring.service';
import { HttpClientModule } from '@angular/common/http';
import { LogViewerDialogComponent } from './archive-dashboard/log-viewer-dialog.component';
import { EventDetailsDialogComponent } from './health/eventdetails-dialog-component';
import { SiteReportModalComponent } from './dailogs/site-report-modal/site-report-modal.component';
import { SiteReportDashboardComponent } from './site-report-dashboard/site-report-dashboard.component';
import { SiteReportService } from './service/site-report.service';
import { SpinnerService } from '../spinner-component/spinner.service';
import { ToastrModule } from 'ngx-toastr';
import { SummaryDetailsPageComponent } from './summary-details-page/summary-details-page.component';


@NgModule({
  declarations: [
    UserBehaviourComponent,
    SessionGraphComponent,
    SessionSummaryComponent,
    UserLogTableComponent,
    SessionBarComponent,
    ActiveUsersDonutChartComponent,
    TimeSinceLoginPipe,
    LogMoreInfoDialogComponent,
    PageDetailsDialogComponent,
    PageActivityTableComponent,
    SiteDetailsDialogComponent,
    RestrictUserDialogComponent,
    HealthCheckComponent,
    VideoComponent,
    EventNewTimelineComponent,
    CameraMappingComponent,
    CameraViewComponent,
    PageSummaryComponent,
    NewTipsComponent,
    NewTipsDialogComponent,
    ChangePasswordDialogComponent,
    PreferencesDialogComponent,
    AssignedUsersDialogComponent,
    SiteSummaryDetailsDialogComponent,
    ConfirmationDailogsComponent,
    ArchiveDashboardComponent,
    QueueDetailsModalComponent,
    CameraIdsDialogComponent,
    SummaryDetailsPageComponent,
    VideoProgressComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UserBehaviourRoutingModule,
    MaterialModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    MatSnackBarModule,
    MatTooltipModule,
    AgGridModule,
    MatDialogModule,
    HttpClientModule,
    ToastrModule,
    DateFormatPipe,
    DashboardComponent,
    LogViewerDialogComponent,
    ConfirmationDialogComponent,
    PerformanceDetailsDialogComponent,
    SiteReportModalComponent,
    SiteReportDashboardComponent,
    UserManagementComponent,
    AddEditUserDialogComponent,
    EventDetailsDialogComponent
  ],
  providers: [
    ArchiveDashboardService,
    PerformanceMonitoringService,
    SiteReportService,
    SpinnerService
  ],
  exports:[
    MaterialModule
  ]
})
export class UserBehaviourModule { }
